import Routes from "./routes/Routes";
// import "style/global.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  add_user_data,
  change_login,
  reset_state,
  full_page_loader,
  set_dashboard_loaded,
  change_app_language,
  change_audio_language,
  setFeatureAvailability,
} from "redux/actions/AppActions";
import { constants } from "redux/constants/redux-constants";
import jwtDecode from "jwt-decode";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth } from "firebase-setup";
import {
  GET_ORGANISATION_FROM_TENENT_ID,
  GET_ORGANISATION_FROM_UID,
  GET_PERSON_FROM_UID,
  GET_PRACTITIONER_FROM_UID,
  LOGOUT_FROM_SERVER,
} from "adapters/auth.service";
import { initializeGlobalSyncPoller } from "../services/globalSyncPoller";
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins.pkgd.min.js";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/plugins.pkgd.min.css";
import {
  set_current_user_practice_data,
  set_current_user_setting,
  set_organistion_details,
  set_person_details,
  set_practitioner_details,
  set_related_persons_details,
  set_user_template_preferences,
  set_voice_edit_setting,
} from "redux/actions/AuthActions";
import _, { get, isEqual, template } from "lodash";
import UnauthorizedAccess from "components/dialogs/UnauthorizedAccess";
import FallBackLoader from "components/loader/FallbackLoader";
import {
  CREATE_PRACTITIONER,
  GET_CUSTOMER_SUBSCRIPTION,
  GET_BASIC_RESOURCE,
  GET_DEFAULT_TEMPLATE_PREFERENCES,
  GET_PLANS_LIST,
  GET_PRACTITIONER,
  GET_PROMPT_LIST,
  GET_RELATED_PERSONS,
  GET_TEMPLATE_PREFERENCES,
  GET_USER_PRACITCE_DATA,
  GET_USER_SETTINGS,
  GET_VOICE_EDIT_SETTINGS,
  SAVE_TEMPLATE_PREFERENCES,
  SAVE_USER_SETTINGS,
  SAVE_VOICE_EDIT_SETTINGS,
  GET_ARCHIVED_ENCOUNTERS,
  GET_FEATURE_AVAILABILITY,
} from "adapters/ehr.service";
import dayjs from "dayjs";
import getCurrentLanguage from "./getCurrentLanguage";
import { getAvailablePrompts } from "config/helpers/prompts";
import {
  cacheTenantIds,
  filterOldObjectsWithModifiedDays,
  handleBulkDeleteEncounter,
  killIntervals,
} from "config/helpers/common_helper";
import { getAvailableTemplates } from "components/SpeechToText_v2/helpers/getAvailbleTemplates";
import {
  reset_subscription,
  set_available_plans,
  set_current_subscription,
} from "redux/actions/SubscriptionAction";
import getCurrentAudioLanguage from "./getCurrentAudioLanguage";
import { TRIAL } from "config/helpers/license_helper";
import { setLicense, setPlanStatus } from "redux/actions/LicenseAction";
import {
  isFeatureAvailable,
  parseLicenseFromSetting,
  upgradeLicense,
} from "config/helpers/licensing_helper";
import { getCurrentPlan, getPlanStatus } from "screens/store/storeHelper";
import IdleController from "components/idle/IdleController";
import { setTokenExpired } from "redux/actions/TokenActions";
import { isLocaleAvailable } from "multilingual";
import { setNJTemplateUser } from "redux/actions/NJTemplateUserActions";
import { GET_EHR_CONNECTION_STATUS } from "adapters/ehrbridge.service";
import { setEHRData } from "redux/reducers/IntegratedEHRSlice";
import { restartInterruptedTasks } from "redux/redux-thunk/BackgroundtaskThunks";

const App = ({ setDatadogUser }) => {
  const reduxDispatch = useDispatch();
  const navigate = useNavigate();
  let shouldShowTrialScreen = false;

  // const language = useSelector((state) => state.app?.language, isEqual);
  // const app = useSelector((state) => state.app, isEqual);
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [isFirebaseLoaded, setIsFirebaseLoaded] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [isUserDataLoaded, setIsUserDataLoaded] = useState(false);
  const [open, setOpen] = useState(false);

  const getPromptList = async () => {
    const availablePrompts = await getAvailableTemplates();
    console.log("prompts", availablePrompts);

    const isNJTemplateUser = availablePrompts?.some((prompt) =>
      prompt.promptName.toLowerCase().includes("women")
    );
    reduxDispatch(setNJTemplateUser(isNJTemplateUser));
    reduxDispatch(set_user_template_preferences({ display: availablePrompts }));
  };

  const getUserSubscription = async () => {
    const currentSubscription = await GET_CUSTOMER_SUBSCRIPTION();

    if (currentSubscription) {
      reduxDispatch(set_current_subscription(currentSubscription));
      return currentSubscription;
    }
  };

  const getPlans = async () => {
    try {
      const res = await GET_PLANS_LIST();
      reduxDispatch(set_available_plans(res?.products));
      return res?.products;
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    setCurrentLocation(window.location?.pathname);
  }, [window.location]);

  useEffect(() => {
    reduxDispatch(restartInterruptedTasks());
  }, [reduxDispatch]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        let roles = user?.reloadUserInfo?.customAttributes
          ? JSON.parse(user?.reloadUserInfo?.customAttributes)
          : { enlivRoles: [] };
        if (navigator?.onLine && roles?.enlivRoles?.includes("portal_user")) {
          setOpen(true);
          signOut(auth)
            ?.then(() => {
              let tenantsList = localStorage.getItem("tenants") || "[]";
              localStorage?.clear();
              localStorage.setItem("tenants", tenantsList);
              setFirebaseUser(null);
              setIsFirebaseLoaded(true);
            })
            .catch((e) => {
              console.log(`some issue in firebase signout`, e);
            });
          reduxDispatch(full_page_loader(false));
          return false;
        }
        setFirebaseUser(user);
        user
          ?.getIdToken()
          ?.then((token) => {
            localStorage?.setItem("jwtToken", token);
            const jwtPayLoad = jwtDecode(token);
            reduxDispatch(
              add_user_data({
                resource: jwtPayLoad,
                userId: jwtPayLoad?.user_id,
              })
            );
            reduxDispatch(change_login(constants?.USER_CHECK_LOGIN));
            setDatadogUser(
              jwtPayLoad?.name,
              jwtPayLoad?.email,
              jwtPayLoad?.firebase?.tenant
            );
            setIsFirebaseLoaded(true);
          })
          .catch((error) => {
            setFirebaseUser(null);
            setIsFirebaseLoaded(true);
          });
      } else {
        setFirebaseUser(null);
        setIsFirebaseLoaded(true);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    refreshUserData(firebaseUser, isFirebaseLoaded);
  }, [firebaseUser, isFirebaseLoaded]);

  const createUserSetting = async (userId) => {
    const language = getCurrentLanguage();
    const audioLanguage = getCurrentAudioLanguage();

    // const systemLanguage = navigator?.language || navigator?.userLanguage;
    // const languageCode = language || systemLanguage.split("-")[0] || "en";
    const languageCode = language || isLocaleAvailable() || "en";
    const audioLanguageCode =
      // audioLanguage || systemLanguage.split("-")[0] || "en";
      audioLanguage || isLocaleAvailable() || "en";

    let setting = {
      theme: "light",
      language: languageCode || "en",
      isIntroDone: false,
      isNewUser: true,
      isWelcomeScreenShown: false,
      audioLanguage: audioLanguageCode || "en",
      print_watermark: true,
      dashboard_selected_widgets: [
        "Start Encounter",
        "Search Patient",
        "Create Patient",
        "Clinical Notes",
      ],
      auto_delete_days: "never",
      CDSSHidden: false,
      diagnosisJustification: false,
      RememberSOAPContextCarryForward: "ask",
      secondaryDiagnosis: false,
      clinicalNoteLanguage: "English",
    };

    let payload = {
      resourceType: "Basic",
      code: {
        coding: [
          {
            system: "http://enliv.com/code/basic-resource-type",
            code: "user.preference.ui",
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format("YYYY-MM-DD"),
      extension: [
        {
          url: "http://enliv.com/settings/data",
          valueString: JSON.stringify(setting),
        },
      ],
    };

    const response = await SAVE_USER_SETTINGS(`POST`, payload);
    return response;
  };

  const providerPracticeData = async (userId) => {
    const practice_data = {
      practice_speciality: null,
      practice_ehr: null,
      isFirstVisitSkipped: false,
    };

    let payload = {
      resourceType: "Basic",
      code: {
        coding: [
          {
            system: "http://enliv.com/code/basic-resource-type",
            code: "user.preference.practice",
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format("YYYY-MM-DD"),
      extension: [
        {
          url: "http://enliv.com/practice/data",
          valueString: JSON.stringify(practice_data),
        },
      ],
    };

    const response = await SAVE_USER_SETTINGS(`POST`, payload);
    return response;
  };
  const createVoiceEditSetting = async (userId) => {
    let setting = {
      voiceEditTime: 0,
      voiceEditCount: 0,
    };

    let payload = {
      resourceType: "Basic",
      code: {
        coding: [
          {
            system: "http://enliv.com/code/basic-resource-type",
            code: "user.voiceEdit.time",
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format("YYYY-MM-DD"),
      extension: [
        {
          url: "http://enliv.com/settings/data",
          valueString: JSON.stringify(setting),
        },
      ],
    };

    const response = await SAVE_VOICE_EDIT_SETTINGS(`POST`, payload);
    return response;
  };

  const createUserTemplatePreferences = async (userId) => {
    let userTemplatePreferences = [];

    let payload = {
      resourceType: "Basic",
      code: {
        coding: [
          {
            system: "http://enliv.com/code/basic-resource-type",
            code: "user.template.preferences",
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format("YYYY-MM-DD"),
      extension: [
        {
          url: "http://enliv.com/user_template_preferences/data",
          valueString: JSON.stringify(userTemplatePreferences),
        },
      ],
    };

    const response = await SAVE_TEMPLATE_PREFERENCES(`POST`, payload);
    return response;
  };

  const createDefaultUserTemplatePreferences = async (userId) => {
    let userTemplatePreferences = {
      defaultTemplate: "Soap Note for First Visit",
    };

    let payload = {
      resourceType: "Basic",
      code: {
        coding: [
          {
            system: "http://enliv.com/code/basic-resource-type",
            code: "user.default.template",
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format("YYYY-MM-DD"),
      extension: [
        {
          url: "http://enliv.com/user_default_template/data",
          valueString: JSON.stringify(userTemplatePreferences),
        },
      ],
    };

    const response = await SAVE_TEMPLATE_PREFERENCES(`POST`, payload);
    return response;
  };

  const createPractitionerFromPerson = async (personPayload, uid) => {
    personPayload.resourceType = "Practitioner";
    if (Object.hasOwn(personPayload, "extension")) {
      delete personPayload.extension;
    }

    if (Object.hasOwn(personPayload, "meta")) {
      delete personPayload.meta;
    }

    if (Object.hasOwn(personPayload, "id")) {
      delete personPayload.id;
    }

    personPayload.identifier = [
      {
        system: "http://enliv.com/user-id",
        type: {
          coding: [
            {
              code: "UID",
              system: "http://enliv.com/user-id",
              userSelected: false,
            },
          ],
        },
        use: "usual",
        value: uid,
      },
    ];

    personPayload.qualification = [
      {
        code: {
          coding: [
            {
              code: "207L00000X",
              display: "Anesthesiology",
              system: "http://nucc.org/provider-taxonomy",
            },
          ],
          text: "Anesthesiology",
        },
      },
    ];

    return await CREATE_PRACTITIONER(personPayload);
  };

  const addLicense = async (userId, license = TRIAL) => {
    let license_package = {
      license: license,
      resetCount: 0,
      payload: {
        cdss: 0,
        encounters: 0,
        scribes: 0,
        minutes: 0,
        icd_cpt_codes: 0,
        ai_voice_edit: 0,
        each_scribe_minutes: 0,
      },
    };
    let payload = {
      resourceType: "Basic",
      code: {
        coding: [
          {
            system: "http://enliv.com/code/basic-resource-type",
            code: "user.license",
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format("YYYY-MM-DD"),
      extension: [
        {
          url: "http://enliv.com/license/data",
          valueString: JSON.stringify(license_package),
        },
      ],
    };

    try {
      const response = await SAVE_USER_SETTINGS(`POST`, payload);
      const rawData = { ...response?.data };
      const licenseSetting = rawData?.extension?.find(
        (item) => item?.url === "http://enliv.com/license/data"
      )?.valueString;
      return { valueString: licenseSetting, id: rawData?.id };
    } catch (e) {
      console.error(e);
    } finally {
    }
  };

  const updateLicenseIfNeeded = async (currentPlan, licenseTempLoad) => {
    if (currentPlan !== licenseTempLoad?.license) {
      // If Current Plan is not equal to plan stored in FHIRBasic, update the FHIRBasic
      const response = await upgradeLicense({
        license: currentPlan,
        id: licenseTempLoad.id,
      });
      reduxDispatch(setLicense(response));
    } else {
      reduxDispatch(setLicense(licenseTempLoad));
    }
  };

  const handleLicenseSetting = async (
    licenseSetting,
    availablePlans,
    currentSubscription,
    PersonID
  ) => {
    const currentPlan =
      availablePlans
        ?.find(
          (plan) =>
            plan?.id ===
            currentSubscription?.subscriptions?.[0]?.obj_data?.plan?.product
        )
        ?.name.toUpperCase() || "TRIAL";
    if (licenseSetting?.data?.total) {
      const licenseTempLoad = parseLicenseFromSetting(licenseSetting);
      if (licenseTempLoad) {
        await updateLicenseIfNeeded(currentPlan, licenseTempLoad);
      }
    } else {
      const newLicenseSetting = await addLicense(PersonID, currentPlan);
      try {
        reduxDispatch(
          setLicense({
            ...JSON.parse(newLicenseSetting?.valueString),
            id: newLicenseSetting?.id,
          })
        );
      } catch (error) {
        console.error("Error parsing new license data", error.message);
      }
    }
  };

  const checkEncExp = async ({ practitionerId, expDaysLimit }) => {
    if (expDaysLimit === "never") return false;
    try {
      let res = await GET_ARCHIVED_ENCOUNTERS(practitionerId, "", 100);
      if (res?.entry?.length > 0) {
        res = res?.entry?.filter(
          (f) => f?.resource?.resourceType !== "Patient"
        );
        if (res?.length > 0) {
          const readyToDel = filterOldObjectsWithModifiedDays(
            res,
            expDaysLimit
          );
          if (readyToDel?.length > 0) {
            await handleBulkDeleteEncounter(readyToDel);
          }
        }
      }
    } catch (e) {
      console.error("error: ", e);
    }
  };

  const getLoggedInPersonData = async (uid) => {
    setIsUserDataLoaded(false);
    getPromptList();
    const currentSubscription = await getUserSubscription();
    try {
      const data = await GET_EHR_CONNECTION_STATUS();
      if (!data?.ehrName) {
        reduxDispatch(setEHRData({}));
      } else {
        reduxDispatch(setEHRData({ ...data, connectionId: "dummy" }));
        await initializeGlobalSyncPoller();
      }
    } catch (err) {
      reduxDispatch(setEHRData({}));
    }
    reduxDispatch(
      setPlanStatus(getPlanStatus(currentSubscription?.subscriptions))
    );
    const availablePlans = await getPlans();
    try {
      let response = await GET_PERSON_FROM_UID(uid);
      const PersonID = response?.resource?.id;
      const jwtPayload = jwtDecode(localStorage.getItem("jwtToken"));
      const tenantId = jwtPayload?.firebase?.tenant;
      if (tenantId) {
        checKFeatureAvailability();
      }
      if (PersonID) {
        reduxDispatch(set_person_details(response?.resource));
        // let resource = await GET_RELATED_PERSONS(
        //   response?.resource?.link || []
        // );
        // reduxDispatch(set_related_persons_details(resource));

        const OrganisationData = await GET_ORGANISATION_FROM_TENENT_ID(
          tenantId
        );
        reduxDispatch(set_organistion_details(OrganisationData?.resource));

        let PractitionerData = await GET_PRACTITIONER_FROM_UID(uid);
        if (!PractitionerData?.resource?.id) {
          // PractitionerData = await createPractitionerFromPerson(
          //   { ...response?.resource },
          //   uid
          // )
          alert(
            "Oops! There was an error loading your data. The page will now refresh."
          );
          window.location.reload();
        }

        reduxDispatch(
          set_practitioner_details(
            PractitionerData?.resource || PractitionerData?.data
          )
        );

        let currentUserPracticeData = await GET_USER_PRACITCE_DATA(PersonID);
        let currentUserSetting = await GET_USER_SETTINGS(PersonID);
        let licenseSetting = await GET_BASIC_RESOURCE({
          resourceName: "user.license",
          personId: PersonID,
        });
        handleLicenseSetting(
          licenseSetting,
          availablePlans,
          currentSubscription,
          PersonID
        );

        if (currentUserPracticeData?.data?.total) {
          const rawData = {
            ...currentUserPracticeData?.data?.entry?.[0]?.resource,
          };
          const practiceData = rawData?.extension?.find(
            (item) => item?.url === "http://enliv.com/practice/data"
          )?.valueString;

          reduxDispatch(
            set_current_user_practice_data({
              resource: { ...rawData },
              practiceData: JSON?.parse(practiceData),
            })
          );
        } else {
          const practiceResponse = await providerPracticeData(PersonID);
          reduxDispatch(
            set_current_user_practice_data({
              resource: { ...practiceResponse?.data },
              practiceData: JSON?.parse(
                await practiceResponse?.data?.extension?.[0]?.valueString
              ),
            })
          );
        }
        let auto_delete_days;
        if (currentUserSetting?.data?.total) {
          const rawData = {
            ...currentUserSetting?.data?.entry?.[0]?.resource,
          };
          const displaySetting = rawData?.extension?.find(
            (item) => item?.url === "http://enliv.com/settings/data"
          )?.valueString;

          let savedSettings = JSON?.parse(displaySetting);
          auto_delete_days = savedSettings?.auto_delete_days;
          const supportedLanguages = ["en", "es", "fr-FR", "pl-PL"];
          if (
            !savedSettings?.language ||
            !supportedLanguages.includes(savedSettings?.language)
            // (savedSettings?.language !== "en" &&
            //   savedSettings?.language !== "es" && savedSettings?.language !== "pl" && savedSettings?.language !== "fr")
          ) {
            const systemLanguage =
              navigator?.language || navigator?.userLanguage || "en";
            const languageCode = systemLanguage.split("-")[0];
            savedSettings.language = languageCode || "en";
          }
          if (savedSettings?.isWelcomeScreenShown === false) {
            shouldShowTrialScreen = true;
          }
          if (!savedSettings?.clinicalNoteLanguage) {
            savedSettings.clinicalNoteLanguage = "English";
          }
          reduxDispatch(
            set_current_user_setting({
              resource: { ...rawData },
              display: {
                ...savedSettings,
                //  theme: "light"
              },
            })
          );
          reduxDispatch(
            change_audio_language(savedSettings?.audioLanguage || "en")
          );
        } else {
          shouldShowTrialScreen = true;
          const responseSetting = await createUserSetting(PersonID);
          reduxDispatch(
            set_current_user_setting({
              resource: { ...responseSetting?.data },
              display: JSON?.parse(
                responseSetting?.data?.extension?.[0]?.valueString
              ),
            })
          );
          auto_delete_days = JSON?.parse(
            responseSetting?.data?.extension?.[0]?.valueString
          )?.auto_delete_days;
        }

        await checkEncExp({
          practitionerId: PractitionerData?.resource?.id,
          expDaysLimit: auto_delete_days || "never", // If auto_delete_days is not defined then setting it to 90 days by default to automatically delete encounters after they have been soft deleted
        });

        let voiceEditSettings = await GET_VOICE_EDIT_SETTINGS(PersonID);
        // debugger;
        if (voiceEditSettings?.data?.total) {
          const rawData = {
            ...voiceEditSettings?.data?.entry?.[0]?.resource,
          };
          const displaySetting = rawData?.extension?.find(
            (item) => item?.url === "http://enliv.com/settings/data"
          )?.valueString;

          let savedSettings = JSON?.parse(displaySetting);
          reduxDispatch(
            set_voice_edit_setting({
              resource: { ...rawData },
              display: {
                ...savedSettings,
              },
            })
          );
        } else {
          const responseSetting = await createVoiceEditSetting(PersonID);
          reduxDispatch(
            set_voice_edit_setting({
              resource: { ...responseSetting?.data },
              display: JSON?.parse(
                responseSetting?.data?.extension?.[0]?.valueString
              ),
            })
          );
        }

        setIsUserDataLoaded(true);
      }
    } catch (e) {
      reduxDispatch(full_page_loader(false));
      throw e;
      console.error(e);
    } finally {
      reduxDispatch(full_page_loader(false));
    }
  };

  const checKFeatureAvailability = async () => {
    try {
      const response = await GET_FEATURE_AVAILABILITY();

      const featuresArray = Array.isArray(response?.data)
        ? response.data.map((feature) => feature.feature_flag_code)
        : [];

      reduxDispatch(setFeatureAvailability(featuresArray));
    } catch (error) {
      console.error("Error checking feature availability:", error);
      reduxDispatch(setFeatureAvailability([]));
    }
  };

  const refreshUserData = async (firebaseUser, isFirebaseLoaded) => {
    if (isFirebaseLoaded) {
      reduxDispatch(full_page_loader(true));
      if (firebaseUser) {
        await getLoggedInPersonData(firebaseUser?.uid);
        if (shouldShowTrialScreen && getCurrentPlan() === "TRIAL") {
          navigate(`/welcome`, { replace: true, state: { newUser: true } });
        } else {
          if (currentLocation === "/login") {
            navigate(`/home/dashboard`, { replace: true });
          }
        }
        cacheTenantIds({
          tenantId: firebaseUser?.tenantId,
          email: firebaseUser?.email,
        });
      } else {
        // const tempLang = language;
        const language = getCurrentLanguage();
        reduxDispatch(change_login(constants?.USER_LOGOUT));
        reduxDispatch(reset_state());
        reduxDispatch(change_app_language(language || "en"));
        // navigate(`/login`, { replace: true });
        setIsUserDataLoaded(true);
      }
    }
  };

  const [exitButtonLoading, setExitButtonLoading] = useState(false);

  const handleLogout = async () => {
    try {
      setExitButtonLoading(true);
      killIntervals();
      const language = getCurrentLanguage();
      reduxDispatch(change_login(constants?.USER_LOGOUT));
      reduxDispatch(reset_state());
      reduxDispatch(change_app_language(language || "en"));
      reduxDispatch(reset_subscription());
      let logoutData = await LOGOUT_FROM_SERVER();
      reduxDispatch(setTokenExpired(true));
    } catch (err) {
    } finally {
      setExitButtonLoading(false);
    }
  };

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      const handleMessage = (event) => {
        if (event.data?.type === "NEW_VERSION") {
          console.log("Received version update:", event.data);
          const confirmUpdate = window.confirm(
            `A new version (${event.data.version}) is available!\n\nClick on OK to reload.`
          );

          // Reload the page if the user confirms
          if (confirmUpdate) {
            window.location.reload();
          }
        }
      };

      // Listen for messages from the controlling service worker
      navigator.serviceWorker.controller?.addEventListener(
        "message",
        handleMessage
      );

      // Handle future controller changes
      const handleControllerChange = () => {
        navigator.serviceWorker.controller?.addEventListener(
          "message",
          handleMessage
        );
      };

      navigator.serviceWorker.addEventListener(
        "controllerchange",
        handleControllerChange
      );

      return () => {
        navigator.serviceWorker.controller?.removeEventListener(
          "message",
          handleMessage
        );
        navigator.serviceWorker.removeEventListener(
          "controllerchange",
          handleControllerChange
        );
      };
    }
  }, []);

  return (
    <>
      <UnauthorizedAccess open={open} setOpen={setOpen} />
      <IdleController
        handleLogout={handleLogout}
        exitButtonLoading={exitButtonLoading}
      />
      {(isFirebaseLoaded && isUserDataLoaded && (
        <>
          {/* <JoyrideImplementation /> */}

          <Routes />
        </>
      )) || <FallBackLoader loaderMessage={true} />}
    </>
  );
};

export default App;